import { gql } from "@apollo/client";

export const CREATE_COUNCIL_POSITION = gql`
  mutation CreateCouncilPositions($input: councilPositionsInput) {
    createCouncilPositions(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
      data {
        positionsNameKh
        positionsNameEng
        _id
      }
    }
  }
`;

export const UPDATE_COUNCIL_POSITION = gql`
  mutation UpdateCouncilPositions($id: ID!, $input: councilPositionsInput) {
    updateCouncilPositions(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_COUNCIL_POSITION = gql`
  mutation DeleteCouncilPositions($id: ID!) {
    deleteCouncilPositions(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_COUNCIL_POSITION_PAGINATION = gql`
  query GetCouncilPositionsPagination(
    $page: Int
    $limit: Int
    $keyword: String
    $pagination: Boolean
  ) {
    getCouncilPositionsPagination(
      page: $page
      limit: $limit
      keyword: $keyword
      pagination: $pagination
    ) {
      data {
        _id
        isDefault
        positionsNameKh
        positionsNameEng
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;
